import {
    update,
    approvalsOf,
} from './model';
import { makeTransduce as makeTransduce_ } from './transducer';
import { demoApprovals } from './demoWiring';

const init = (store, features = {}) => {

};

const makeTransduce = ({apiUrl}) => {
    const config = {
        approvals: demoApprovals
    };

    return makeTransduce_(config);

};

export {
    update,
    makeTransduce,
    approvalsOf,
    init
};



// WEBPACK FOOTER //
// ./src/approvals/index.js